/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";

const DataTable = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch("https://dummyjson.com/users")
      .then((res) => res.json())
      .then((data) => {
        setUsers(data.users); // Extract 'users' array
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching users:", err);
        setError("Failed to load users.");
        setLoading(false);
      });
  }, []);

  const TableLoader = ({ rows = 10, columns = 10 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="text-center">
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "20px",
                  width: colIndex === 0 ? "20%" : "70%", // Adjust width for variety
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );



  return (
    <div className="dashboard-body">
      <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
        <h2 className="text-xl font-bold mb-4">Data Table</h2>
        <div className="card mt-24">
          <div
            className="card-header table-responsive"
            style={{ padding: "10px" }}
          >
            <table className="table table-striped dataTable">
              <thead>
                <tr className="">
                  <th className="h5 text-gray-300" scope="col">
                    ID
                  </th>
                  <th className="h5 text-gray-300" scope="col">
                    Name
                  </th> <th className="h5 text-gray-300" scope="col">
                    Email
                  </th> <th className="h5 text-gray-300" scope="col">
                    Phone
                  </th>
                  <th className="h5 text-gray-300" scope="col">
                    Company
                  </th>
                  <th className="h5 text-gray-300" scope="col">
                    City
                  </th>
                </tr>
              </thead>
              {/* {loading ? (
                <TableLoader rows={5} columns={3} /> // Show custom loader
              ) : ( */}
                <tbody>
                  {users.map((user) => (
                    <tr key={user.id} className="hover:bg-gray-100">
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.id}
                      </td>
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.firstName} {user.lastName}
                      </td>
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.email}
                      </td>
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.phone}
                      </td>
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.company.name}
                      </td>
                      <td className="h6 mb-0 fw-medium text-gray-300">
                        {user.address.city}
                      </td>
                     
                    </tr>
                  ))}
                </tbody>
              {/* )} */}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
